// Figures the site quotes about the service. Pages import them, and the build
// reads this file (plugins/site-facts.mjs) for the crawler HTML and JSON-LD, so
// changing a number here updates every copy.

// Contraceptive pill supplies completed by our pharmacists. NHS Pharmacy
// Contraception Service data records 17,292 consultations at the pharmacy
// (Orford Pharmacy, FW716) from July 2025 to June 2026, so this is
// conservative. Only raise it to a number the team can evidence.
export const SUPPLIES_COMPLETED = "12,000";

// Use it where it helps the reader (who they will speak to, choosing a pill,
// whether the service is safe), worded for that page, not as a repeated slogan.
